/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * font size of database entries
 * @export
 */
export const DatabaseFontSizeEnum = {
    _8px: '8px',
    _10px: '10px',
    _12px: '12px',
    _14px: '14px',
    _16px: '16px',
    _18px: '18px',
    _20px: '20px',
    _22px: '22px',
    _24px: '24px',
    _26px: '26px',
    _28px: '28px',
    _32px: '32px',
    _36px: '36px',
    _40px: '40px',
    _48px: '48px',
    _54px: '54px',
    _66px: '66px',
    _72px: '72px',
    _80px: '80px',
    _88px: '88px',
    _96px: '96px',
    _110px: '110px'
} as const;
export type DatabaseFontSizeEnum = typeof DatabaseFontSizeEnum[keyof typeof DatabaseFontSizeEnum];


export function DatabaseFontSizeEnumFromJSON(json: any): DatabaseFontSizeEnum {
    return DatabaseFontSizeEnumFromJSONTyped(json, false);
}

export function DatabaseFontSizeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseFontSizeEnum {
    return json as DatabaseFontSizeEnum;
}

export function DatabaseFontSizeEnumToJSON(value?: DatabaseFontSizeEnum | null): any {
    return value as any;
}

